<template>
<div class = "w-100">
  <div class = "catalogBG">
  <h1>каталог товаров</h1>
  <p>Позволь себе выглядеть на миллион без миллиона</p>
</div>
  <div class = "breadCrumb">
    <div>
      <p>
        <router-link tag = "a"
                     to = "/">
          Главная
        </router-link>/Каталог товаров
      </p>
      <!--<div
        class = "btnSale">
        <a class = "btn-floating"
           v-mdb-waves = "{ background: 'rgba(153,216,208,0.5)', center: true }"
           @click="showModalShopping"
        >
          <i class = "fas fa-shopping-bag"></i>
        </a>
        <span v-if="saleCard.length" class = "counter">{{saleCard.length}}</span>
      </div>-->
    </div>
  </div>
  <Sales/>
  <!--  <ModalShopping  :modalShopData="modalShopData" @hideModalShopping="hideModalShopping" />-->
</div>
</template>
<script>
  //import {mdbWaves} from "mdbvue";
  import Sales from '@/components/Sales';
  //import {mapGetters} from 'vuex';
  //import ModalShopping from '@/components/ModalShopping'

  export default {
    name: "Catalog",
    components: {
      Sales,
      //ModalShopping
    },
    /*      data() {
                  return{
                    modalShopData: {relatedIn: false,}
                  }
                },
                directives: {
                  mdbWaves
                },
                computed:{
                  ...mapGetters([
                    'saleCard',
                  ]),
                },
                methods: {
                  showModalShopping (){
                    this.modalShopData.relatedIn = !!this.saleCard.length;
                  },
                  hideModalShopping (data){
                    this.modalShopData = data;
                  },
                },*/
  }
</script>

<style lang = "scss">

</style>
